export default "__VITE_ASSET__Dfs3ycuk__"